import { renderMarkdown } from '@karakuri-web/common/react-render-markdown'

import { detectTable } from './detectTable'
import { AnswerContent as AnswerContentType, SkillApi } from './interface'
import { renderSkill } from './Skill'
import { renderText } from './Text'
import { detectVideoTouch } from './videoTouch/videoTouch'
import { VideoTouchIframe } from './videoTouch/VideoTouchIframe'
import { detectYoutube } from './youtube/youtube'
import { YoutubeIframe } from './youtube/YoutubeIframe'

export function render(content: AnswerContentType, skillApi: SkillApi, cardId: string) {
  const contentText = content?.text || ''

  if (content.contentFormat === 'markdown') {
    return <div className="md">{renderMarkdown(contentText)}</div>
  }
  if (detectTable(contentText)) {
    return <div className="faq-answer-table md" dangerouslySetInnerHTML={{ __html: contentText }} />
  }
  if (detectYoutube(content)) {
    return <YoutubeIframe youtubeId={content.meta.youtubeId} />
  }
  if (detectVideoTouch(content)) {
    return <VideoTouchIframe videoTouchId={content.meta.videoTouchId} />
  }
  const skill = renderSkill(skillApi, {
    from: 'FAQ_ANSWER',
    text: content.text,
    cardId,
    answerId: content.id,
  })

  if (skill) {
    return skill
  }

  const text = contentText.endsWith('\n') ? contentText : contentText ? `${content.text}\n` : ''
  return renderText(text)
}
